import { render, staticRenderFns } from "./InputInboxDraft.vue?vue&type=template&id=28e95ab2&"
import script from "./InputInboxDraft.vue?vue&type=script&lang=js&"
export * from "./InputInboxDraft.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxDraft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports